import Link from '@mui/material/Link'
import Chip from '@mui/material/Chip'
import LanguageIcon from '@mui/icons-material/Language'

function DomainChip({ domain, path = '' }) {
  const domainName = domain?.domain || ''
  const safePath = path || ''
  const url = `https://${domainName}${safePath}`

  return (
    <Chip
      icon={<LanguageIcon />}
      label={`${domainName}${safePath}`}
      size="small"
      color="primary"
      clickable
      component={Link}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        '&:hover': {
          textDecoration: 'underline !important',
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onMouseUp={(e) => {
        e.stopPropagation();
      }}
    />
  )
}

export default DomainChip
